export enum ApiRequest {
	// Auth (Rust API)
	AuthLogin = 'auth/login',
	AuthRegister = 'auth/register',
	AuthRefresh = 'auth/refresh',
	AuthLogout = 'auth/logout',
	// Quick-unlock (PIN / biometric) + WebAuthn (SHADOW, gated by QUICK_UNLOCK_ENABLED)
	QuickUnlockEnroll = 'auth/quick-unlock/enroll',
	QuickUnlockLogin = 'auth/quick-unlock/login',
	WebauthnRegisterStart = 'auth/webauthn/register/start',
	WebauthnRegisterFinish = 'auth/webauthn/register/finish',
	WebauthnLoginStart = 'auth/webauthn/login/start',
	WebauthnLoginFinish = 'auth/webauthn/login/finish',

	// Market Data (Rust API)
	Symbols = 'symbols',
	Ticker = 'ticker',
	Tickers = 'tickers',
	Candles = 'candles',
	CommodityCandles = 'commodities/candles',
	Quizzes = 'quizzes', // + `/${module}`, `/${module}/submit`, `/progress`
	CommoditiesOverview = 'commodities/overview',
	CommoditySpread = 'commodities/spread',
	CommodityMacro = 'commodities/macro',
	CommodityMacroSeries = 'commodities/macro/series',
	CommodityMacroDashboard = 'commodities/macro/dashboard',
	CommodityMacroAnalytics = 'commodities/macro/analytics',
	CommodityMacroEvents = 'commodities/macro/events',
	CommodityGeo = 'commodities/geo',
	CommoditySessions = 'commodities/sessions',
	CommoditiesMasters = 'commodities/masters',
	CommoditiesMastersShadow = 'commodities/masters/shadow',
	CommoditiesMastersCycles = 'commodities/masters/cycles',
	CommoditiesEiaA1Shadow = 'commodities/eia-a1-shadow',
	CommoditiesSrLevels = 'commodities/sr-levels',
	CommoditiesShadowStrategies = 'commodities/shadow-strategies',
	CommoditiesGeoMap = 'commodities/geo-map',
	MarketOverview = 'market/overview',
	MarketFx = 'market/fx',
	MarketOverviewCursor = 'market/overview/cursor',
	MarketCandlesLatest = 'market/candles/latest',
	MarketTickersLive = 'market/tickers/live',
	MarketSummary = 'market/summary',
	MarketFuturesSymbols = 'market/futures-symbols',
	MarketFunding = 'market/funding',
	MarketSma200Trend = 'market/sma200-trend',
	MarketTrendStrategy = 'market/trend-strategy',
	MarketExposureGate = 'market/exposure-gate',
	MarketExposureGateHistory = 'market/exposure-gate/history',
	MarketBreadthIndex = 'market/breadth-index',
	MarketVolumeTrend = 'market/volume-trend',
	MarketVolumeRegime = 'market/volume-regime',
	MarketVolumeRegimeHistory = 'market/volume-regime/history',
	MarketRegimeNowcast = 'market/regime-nowcast',
	MarketRegimeMonthly = 'market/regime-monthly',
	MarketBreadthForwardAnalytics = 'market/breadth-forward-analytics',
	MarketVolumeSpikes = 'market/volume-spikes',
	MarketVolumeDivergence = 'market/volume-divergence',
	MarketVolumeHourly = 'market/volume-hourly',
	MarketTakerRatio = 'market/taker-ratio',
	MarketVolumeHistory = 'market/volume-history',
	MarketManipulability = 'market/manipulability',
	MarketTrendFromLow = 'market/trend-from-low',
	MarketTrendLowIndex = 'market/trend-from-low/index',
	MarketBottoms = 'market/bottoms',
	MarketCatchTrend = 'market/catch-trend',
	MarketCatchTrendTrack = 'market/catch-trend/track',
	MarketCatchTrendLines = 'market/catch-trend/lines',
	MarketCatchTrendSummary = 'market/catch-trend/summary',
	MarketTrendState = 'market/trend-state',
	MarketGainsMonitor = 'market/gains-monitor',
	MarketDailyRange = 'market/daily-range',
	MarketDailyRangeScan = 'market/daily-range/scan',
	MarketOverbalance = 'market/overbalance',
	MarketOverbalanceScan = 'market/overbalance/scan',
	MarketGainsMonitorSummary = 'market/gains-monitor/summary',
	MarketConsolidationSummary = 'market/consolidation-index/summary',
	MarketConsolidationOverview = 'market/consolidation-index/overview',
	TrendsSummary = 'trends/summary',
	MarketGainsValidation = 'market/gains-monitor/validation',
	MarketCvd = 'market/cvd',
	MarketVwap = 'market/vwap',
	MarketVolumeProfile = 'market/volume-profile',
	MarketFootprint = 'market/footprint',
	MarketStructure = 'market/structure',
	MarketOrderBlocks = 'market/order-blocks',
	MarketManipulation = 'market/manipulation',
	MarketDepthHeatmap = 'market/depth-heatmap',
	MarketDemandSupplyLocations = 'market/demand-supply-locations',
	MarketPaStructure = 'market/pa-structure',
	PatternsMlStatus = 'patterns/ml/status',

	// Contact / Sales (Rust API)
	Contact = 'contact',

	// User (Rust API)
	UserMe = 'user/me',

	// Favorites (Rust API)
	Favorites = 'favorites',

	// Sentiment (Rust API)
	SentimentOverview = 'sentiment/overview',
	SentimentHistory = 'sentiment/history',
	SentimentPulseSummary = 'sentiment/breadth-pulse/summary',
	SentimentSignals = 'sentiment/signals',
	SentimentAnalysis = 'sentiment/analysis',
	SentimentQuality = 'sentiment/quality',
	SentimentThresholds = 'sentiment/thresholds',
	SentimentForecast = 'sentiment/forecast',
	SentimentExport = 'sentiment/export',
	SentimentInterpret = 'sentiment/interpret',
	SentimentDemand = 'sentiment/demand',
	SentimentVolumeFlow = 'sentiment/volume-flow',
	SentimentMarketContext = 'sentiment/market-context',
	SentimentPanic = 'sentiment/panic',
	SentimentBreadthChart = 'sentiment/breadth/chart',
	SentimentBreadthTimeline = 'sentiment/breadth/timeline',
	SentimentShift = 'sentiment/shift',

	// Alerts (Rust API)
	AlertRules = 'alerts/rules',
	AlertHistory = 'alerts/history',
	AlertHistoryRead = 'alerts/history/read',
	AlertHistoryReadAll = 'alerts/history/read-all',
	AlertHistoryDelete = 'alerts/history/delete',
	AlertOverview = 'alerts/overview',
	AlertRuleStats = 'alerts/rules/stats',
	AlertPriceLevels = 'alerts/price-levels',
	NotificationPreferences = 'notifications/preferences',

	// Portfolio (Rust API)
	Portfolios = 'portfolios',
	Positions = 'positions',
	PortfolioModel = 'portfolio/model',
	PortfolioModelTrackRecord = 'portfolio/model/track-record',
	PortfolioModelDivergence = 'portfolio/model/divergence',
	PortfolioVolClimate = 'portfolio/vol-climate',
	PortfolioCyclePosition = 'portfolio/cycle-position',
	PortfolioCyclePrediction = 'portfolio/cycle-prediction',
	PortfolioCycleSeasonality = 'portfolio/cycle-seasonality',
	PortfolioCycleSwings = 'portfolio/cycle-swings',
	PortfolioClimateLab = 'portfolio/climate-lab',
	PortfolioCycles = 'portfolio/cycles',
	PortfolioSchedule = 'portfolio/schedule',
	PortfolioClimateScore = 'portfolio/climate-score',
	PortfolioCycleSleeve = 'portfolio/cycle-sleeve',
	PortfolioCycleSleeveTrackRecord = 'portfolio/cycle-sleeve/track-record',
	PortfolioCycleSleeveBlend = 'portfolio/cycle-sleeve/blend',
	PortfolioBasket = 'portfolio/basket',
	PortfolioBasketApply = 'portfolio/basket/apply',

	// Admin (Rust API)
	AdminHealth = 'admin/health',
	AdminDashboard = 'admin/dashboard',
	AdminFreshness = 'admin/freshness',
	AdminSymbols = 'admin/symbols',
	AdminCurrencies = 'admin/currencies',
	AdminCurrenciesSync = 'admin/currencies/sync',
	AdminCoverage = 'admin/coverage',
	AdminGaps = 'admin/gaps',
	AdminPatterns = 'admin/patterns',
	AdminSignals = 'admin/signals',
	AdminCandlesRebuild = 'admin/candles/rebuild',
	AdminCandlesFetchBinance = 'admin/candles/fetch-binance',
	AdminCandlesIntervalStats = 'admin/candles/interval-stats',
	AdminCandlesVerificationLog = 'admin/candles/verification-log',
	AdminCandlesVerificationSummary = 'admin/candles/verification-summary',
	AdminCandlesSyncCoverage = 'admin/candles/sync-coverage',
	AdminCandlesGapScan = 'admin/candles/gap-scan',
	AdminCandlesMonthlyGaps = 'admin/candles/monthly-gaps',
	AdminCandlesAutomationStatus = 'admin/candles/automation-status',
	AdminDataAuditOverview = 'admin/data-audit/overview',
	AdminDataAuditHtfStatus = 'admin/data-audit/htf-status',
	AdminDataAuditCoverageMatrix = 'admin/data-audit/coverage-matrix',
	AdminDataAuditPairDetail = 'admin/data-audit/pair-detail',
	AdminDataAuditMissingScan = 'admin/data-audit/missing-scan',
	AdminDataAuditHealthCheck = 'admin/data-audit/health-check',
	AdminDataAuditSnapshotHistory = 'admin/data-audit/snapshot-history',
	AdminCollectorStatus = 'admin/collector/status',
	AdminCollectorMetrics = 'admin/collector/metrics',
	AdminPatternDetectorConfig = 'admin/pattern-detector-config',
	AdminChMaintenance = 'admin/ch-maintenance',
	AdminUsers = 'admin/users',
	AdminUserCreate = 'admin/users',
	AdminUserTier = 'admin/users', // + `/${id}/tier`
	AdminUserDelete = 'admin/users', // + `/${id}`
	AdminUserStats = 'admin/users/stats',

	// Investing (Rust API)
	InvestingRegime = 'investing/regime',
	InvestingSetupFeed = 'investing/setup-feed',
	InvestingSetupScore = 'investing/setup-score',
	InvestingCalculator = 'investing/calculator',
	InvestingWatchlist = 'investing/watchlist',

	// Support/Resistance (Rust API)
	SrLevels = 'sr/levels',
	SrZoneReliability = 'sr/zone-reliability',
	SrZones = 'sr/zones',
	SrProximity = 'sr/proximity',
	SrSummary = 'sr/summary',
	SrAnalytics = 'sr/analytics',
	SrOpportunities = 'sr/opportunities',
	SrVolumeProfile = 'sr/volume-profile',
	SrTransitions = 'sr/transitions',
	SrBalanceHistory = 'sr/balance/history',
	ObWalls = 'ob/walls',
	MarketLiquidations = 'market/liquidations',

	// Exchange Control (read-only exchange account connections)
	ExchangeConnections = 'exchange/connections',
	ExchangeAccountStatus = 'exchange/account-status',
	ExchangePortfolio = 'exchange/portfolio',
	ExchangeOrders = 'exchange/orders',
	ExchangeOrderSell = 'exchange/orders/sell',
	ExchangeOrderSellPreview = 'exchange/orders/sell/preview',
	ExchangeOrderBuy = 'exchange/orders/buy',
	ExchangeOrderBuyPreview = 'exchange/orders/buy/preview',
	ExchangeTransferAddresses = 'exchange/transfer/addresses',
	ExchangeTransferVerify = 'exchange/transfer/verify',
	ExchangeTransferPreflight = 'exchange/transfer/preflight',
	ExchangeTransferReconcile = 'exchange/transfer/reconcile',
	ExchangeTransferExecute = 'exchange/transfer/execute',
	ExchangeRisk = 'exchange/risk',
	AdminExchangeKillSwitch = 'admin/exchange/kill-switch',

	DashboardPreferences = 'dashboard/preferences',

	// BTC Intelligence (Rust API)
	BtcConviction = 'btc/conviction',
	BtcMarketStructure = 'btc/market-structure',
	BtcWyckoff = 'btc/wyckoff',
	BtcCycle = 'btc/cycle',
	BtcLiquidity = 'btc/liquidity',
	// BTC Capital Flow
	SentimentBtcFlow = 'sentiment/btc-flow',
	SentimentBtcFlowHistory = 'sentiment/btc-flow/history',
}
